import { Component, OnInit } from '@angular/core';
import { DashboardPortefeuilleRisqueService } from '../../core/service/suiviPortefeuille/dashboard-portefeuille-risque.service';
import { first } from "rxjs/operators";
import { ChartViewDTO } from '../../core/model/chart_view/chart-view-dto';
import * as Highcharts from "highcharts";
import { QuantiteDossierSuiviPortefeuilleRisqueDTO } from '../../core/model/QuantiteDossierSuiviPortefeuilleRisqueDTO';
import { QuantiteDossierParMarcheEntrePeriodeDTO } from '../../core/model/QuantiteDossierParMarcheEntrePeriodeDTO';

@Component({
  selector: "app-portefeuille-risque",
  templateUrl: "./portefeuille-risque.component.html",
  styleUrls: ["./portefeuille-risque.component.scss"]
})
export class PortefeuilleRisqueComponent implements OnInit {
  highcharts = Highcharts;

  updateFlagPourcentage: boolean = false;
  updateFlagDossierCree: boolean = false;
  chartOptionsPourcentageParticulier: any;
  chartOptionsPourcentagePme: any;
  chartOptionsPourcentageCorporate: any;

  quantiteDossierSuiviPortefeuilleRisqueDTO: QuantiteDossierSuiviPortefeuilleRisqueDTO = new QuantiteDossierSuiviPortefeuilleRisqueDTO();
  quantiteDossierParMarcheEntrePeriodeDTO: QuantiteDossierParMarcheEntrePeriodeDTO[];

  nombreByPeriode: ChartViewDTO;
  chartOptionsSuiviByPeriode: any;
  quantiteByPeriode: ChartViewDTO;
  chartOptionsQuantiteByPeriode: any;

  constructor(
    private _dashboardPortefeuilleRisqueService: DashboardPortefeuilleRisqueService
  ) {}

  ngOnInit() {
    this.nombrePortefeuilleRisqueFiltrerSurPeriode();
    this.quantitePortefeuilleRisqueSurLes6DerniersMois();
    this.quantiteDossierPortefeuilleRisque();

    this.pourcentageDossierByTypeMarcheParticulier();
    this.pourcentageDossierByTypeMarchePme();
    this.pourcentageDossierByTypeMarcheCorporate();

    this.quantiteDossierPortefeuilleParProduit();
  }

  nombrePortefeuilleRisqueFiltrerSurPeriode() {
    this._dashboardPortefeuilleRisqueService
      .nombrePortefeuilleRisqueFiltrerSurPeriode()
      .pipe(first())
      .subscribe(
        response => {
          this.nombreByPeriode = response;

          this.chartOptionsSuiviByPeriode = {
            chart: {
              type: "spline"
            },
            title: {
              text: "Evolution des dossiers sur les 12 derniers mois"
            },
            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.nombreByPeriode.categories
            },
            yAxis: {
              title: {
                text: "Qté"
              }
            },
            tooltip: {
              valueSuffix: null
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true
            },

            series: this.nombreByPeriode.series
          };
        },
        error => {
          console.log(error);
        }
      );
  }

  quantitePortefeuilleRisqueSurLes6DerniersMois() {
    this._dashboardPortefeuilleRisqueService
      .quantitePortefeuilleRisqueSurLes6DerniersMois()
      .pipe(first())
      .subscribe(
        response => {
          this.quantiteByPeriode = response;

          this.chartOptionsQuantiteByPeriode = {
            chart: {
              type: "column" // Changer le type en "column"
            },
            title: {
              text:
                "Repartition des créances en souffrance sur les 12 derniers mois"
            },
            subtitle: {
              text: null
            },
            xAxis: {
              categories: this.quantiteByPeriode.categories
            },
            yAxis: {
              title: {
                text: "Qté"
              }
            },
            tooltip: {
              valueSuffix: null
            },

            legend: {
              layout: "vertical",
              align: "right",
              verticalAlign: "top",
              x: 0,
              y: 100,
              floating: false,
              borderWidth: 1,

              backgroundColor: "#FFFFFF",
              shadow: true
            },

            plotOptions: {
              column: {
                stacking: "normal", // Ajouter cette ligne pour empiler les colonnes
                dataLabels: {
                  enabled: true
                }
              }
            },

            series: this.quantiteByPeriode.series
          };
        },
        error => {
          console.log(error);
        }
      );
  }

  quantiteDossierPortefeuilleRisque() {
    this._dashboardPortefeuilleRisqueService
      .quantiteDossierSuiviPortefeuilleRisque()
      .pipe(first())
      .subscribe(
        data => {
          this.quantiteDossierSuiviPortefeuilleRisqueDTO = data;
        },
        error => {
          console.log(error);
        }
      );
  }

  hasDataPourcentageParticulier: boolean = false;

  pourcentageDossierByTypeMarcheParticulier() {
    this._dashboardPortefeuilleRisqueService
      .pourcentageDossierPortefeuilleRisqueByTypeMarche("PARTICULIER")
      .pipe(first())
      .subscribe(
        response => {
          const data = [];
          response.forEach(function(value) {
            data.push({ name: value.name, y: value.valeur });
          });
          this.hasDataPourcentageParticulier = data.length > 0;

          this.chartOptionsPourcentageParticulier = {
            chart: {
              plotBorderWidth: null,
              plotShadow: false
            },
            title: {
              text: "Répartition des dossiers de particulier"
            },
            tooltip: {
              pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: "pointer",

                dataLabels: {
                  enabled: false
                },

                showInLegend: true
              }
            },
            series: [
              {
                type: "pie",
                name: "Pourcentage",
                data: data
              }
            ]
          };
          if (data.length > 0) {
            this.updateFlagPourcentage = true;
          }
        },
        error => {
          console.log(error);
        }
      );
  }

  hasDataPourcentagePme: boolean = false;

  pourcentageDossierByTypeMarchePme() {
    this._dashboardPortefeuilleRisqueService
      .pourcentageDossierPortefeuilleRisqueByTypeMarche("PROFESSIONNEL")
      .pipe(first())
      .subscribe(
        response => {
          const data = [];
          response.forEach(function(value) {
            data.push({ name: value.name, y: value.valeur });
          });
          this.hasDataPourcentagePme = data.length > 0;

          this.chartOptionsPourcentagePme = {
            chart: {
              plotBorderWidth: null,
              plotShadow: false
            },
            title: {
              text: "Répartition des dossiers de Professionnel"
            },
            tooltip: {
              pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: "pointer",

                dataLabels: {
                  enabled: false
                },

                showInLegend: true
              }
            },
            series: [
              {
                type: "pie",
                name: "Pourcentage",
                data: data
              }
            ]
          };
          if (data.length > 0) {
            this.updateFlagPourcentage = true;
          }
        },
        error => {
          console.log(error);
        }
      );
  }

  hasDataPourcentageCorporate: boolean = false;

  pourcentageDossierByTypeMarcheCorporate() {
    this._dashboardPortefeuilleRisqueService
      .pourcentageDossierPortefeuilleRisqueByTypeMarche("CORPORATE")
      .pipe(first())
      .subscribe(
        response => {
          const data = [];
          response.forEach(function(value) {
            data.push({ name: value.name, y: value.valeur });
          });
          this.hasDataPourcentageCorporate = data.length > 0;

          this.chartOptionsPourcentageCorporate = {
            chart: {
              plotBorderWidth: null,
              plotShadow: false
            },
            title: {
              text: "Répartition des dossiers de Corporate"
            },
            tooltip: {
              pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: "pointer",

                dataLabels: {
                  enabled: false
                },

                showInLegend: true
              }
            },
            series: [
              {
                type: "pie",
                name: "Pourcentage",
                data: data
              }
            ]
          };
          if (data.length > 0) {
            this.updateFlagPourcentage = true;
          }
        },
        error => {
          console.log(error);
        }
      );
  }

  quantiteDossierPortefeuilleParProduit() {
    this._dashboardPortefeuilleRisqueService
      .quantiteDossierParMarcheEntrePeriodeDTO()
      .pipe(first())
      .subscribe(
        response => {
          this.quantiteDossierParMarcheEntrePeriodeDTO = response;
        },
        error => {
          console.log(error);
        }
      );
  }
}
